import { Store } from '@ngrx/store';
import * as angular from 'angular';
import * as _ from 'lodash';
import { take, tap } from 'rxjs/operators';
import { IStudent } from '../../../../ng2/shared/typings/interfaces/student.interface';
import { PlannedDiplomaOptionsModalCtrl } from './planned-diploma-options.controller';

export class PlannedDiplomaOptionsModal {
  static $inject: string[] = ['$mdDialog', 'Store', 'Student'];

  constructor(private $mdDialog: any, private store: Store<any>, private student: IStudent) {}

  show(selectedStudentIds, selector) {
    return this.$mdDialog.show({
      controller: PlannedDiplomaOptionsModalCtrl,
      controllerAs: '$ctrl',
      locals: {
        selectedStudentIds,
      },
      resolve: {
        selectedStudents: () => {
          if (selector) {
            // Used by grad planning panel in student profile (CM)
            let selectedStudent;
            return new Promise(resolve => {
              this.store
                .select(selector, selectedStudentIds)
                .pipe(
                  tap(fetchedStudent => (selectedStudent = fetchedStudent)),
                  take(1),
                )
                .subscribe();
              return resolve(selectedStudent);
            });
          } else {
            // Used by ng1 sdc grid (CM)
            const selectedStudents = [];
            _.each(selectedStudentIds, studentId => {
              const student = this.student.get({ id: studentId }).$promise;
              selectedStudents.push(student);
            });
            return Promise.all(selectedStudents);
          }
        },
      },
      parent: angular.element(document.body),
      disableParentScroll: true,
      clickOutsideToClose: true,
      template: require('./planned-diploma-options.html'),
    });
  }
}
